import React from "react";
import { useNavigate } from "react-router-dom";
import * as Styled from "../../../CompanyForm.styled.js";
import * as MUIStyled from "../../../MUIStyled.js";
import { ButtonPurple } from "../Buttons/Buttons.styled";
import logo from "../../../images/horizontal-logo.png";

export default function NavBar({ hideContinueButton, currentStep }) {
    const navigate = useNavigate();
    const handleContinue = () => {
        sessionStorage.setItem("currentStep", currentStep);
        navigate("/continueLater");
    };

    return (
        <Styled.NavMainWrapper>
            <Styled.NavAppBar>
                <MUIStyled.CustomToolbar>
                    <Styled.NavBarBox>
                        <Styled.StyledLogo
                            src={logo}
                            alt="Logo"></Styled.StyledLogo>
                    </Styled.NavBarBox>
                    {!hideContinueButton && (
                        <ButtonPurple
                            style={{ width: "140px" }}
                            onClick={handleContinue}>
                            Continue Later
                        </ButtonPurple>
                    )}
                </MUIStyled.CustomToolbar>
            </Styled.NavAppBar>
        </Styled.NavMainWrapper>
    );
}
